// generate a random alphaNum 'length' long
import { format, parse, parseISO } from 'date-fns'

export function randomString(length) {
  let text = ''
  let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  for (let i = 0; i < length; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length))
  }
  return text
}

// get current age by birthDate
export function getAge(birthDate) {
  if (!birthDate) {
    return null
  }
  const today = new Date()

  if (birthDate.includes('-')) {
    birthDate = convertHyphenDateToSlashDate(birthDate)
  }
  let birthDay = new Date(birthDate)
  let age = today.getFullYear() - birthDay.getFullYear()
  const monthDiff = today.getMonth() - birthDay.getMonth()
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDay.getDate())) {
    age -= 1
  }

  return age
}

export function convertDateToDotDate(date) {
  if (!date || date === 'Invalid date') {
    return null
  }

  if (date?.includes('/')) {
    return format(parse(date, 'MM/dd/yyyy', new Date()), 'M.d.yy')
  } else if (date?.includes('-')) {
    return format(parseISO(date), 'M.d.yy')
  }
  console.error('Missing Date dot formatter')
  return ''
}

// capitalize first word of a sentence
export function capitalizeEachWord(sentence) {
  return sentence
    ?.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ')
}

// format bytes into a readable value
export function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
}

export function prettifyDate(date) {
  if (!date) {
    return ''
  }
  return format(new Date(date?.replaceAll('-', '/')), 'MM/dd/yyyy')
}

// rules for when to show lane color banner warnings/details
export function getDisplayDetails() {
  const url = window.location.host
  if (url.includes('stage')) {
    return { laneBannerTitle: 'stage', showLaneBanner: true }
  } else if (url.includes('test')) {
    return { laneBannerTitle: 'test', showLaneBanner: true }
  } else if (url.includes('dev')) {
    return { laneBannerTitle: 'dev', showLaneBanner: true }
  } else {
    return { laneBannerTitle: '', showLaneBanner: false }
  }
}

// take a (hopefully) real number and format it
export function formatPhoneNumber(number) {
  if (!number || number?.length < 10) {
    // bad format
    return number
  }
  number = deformatPhoneNumber(number)
  // if the phone number has more than 10 digits, remove the leading "1" digit
  if (number?.length > 10) {
    number = number?.slice(1, 11)
  }
  return `(${number?.slice(0, 3)}) ${number?.slice(3, 6)}-${number?.slice(6, 10)}`
}

export function deformatPhoneNumber(value) {
  return ('' + value)?.replace(/\D/g, '')
}

export function goBackNavigation(navigate, previousPage) {
  if (previousPage === 'Patient search') {
    navigate('/patientList')
  } else if (previousPage === 'Census') {
    navigate('/census')
  } else if (previousPage === 'New patient') {
    navigate('/patient')
  } else if (previousPage === 'Provider Hold') {
    navigate('/providerhold')
  } else if (previousPage === 'Encounters') {
    navigate('/encounters')
  } else {
    navigate('/census')
  }
}

export function getProviderInitials(providerName) {
  let initials = ''
  if (providerName) {
    let names = providerName.split(' ')
    let firstname = names?.[0]
    let lastname = names?.[1]
    initials = firstname?.[0]

    if (lastname) {
      initials = initials + lastname?.[0]
    }
    initials = initials?.toUpperCase()
  }

  return initials
}

// transforms a MM/DD/YYYY date to a YYYY-MM-DD date
export function convertSlashDateToHyphenDate(slashDate) {
  if (!slashDate || slashDate === 'Invalid date') {
    return null
  }

  const parts = slashDate.split('/')

  return parts[2] + '-' + parts[0].padStart(2, '0') + '-' + parts[1].padStart(2, '0')
}

// transforms a YYYY-MM-DD date to a MM/DD/YYYY date
export function convertHyphenDateToSlashDate(hyphenDate) {
  if (!hyphenDate || hyphenDate === 'Invalid date') {
    return null
  }

  const parts = hyphenDate.split('-')

  if (parts && parts.length > 1) {
    return parts[1].padStart(2, '0') + '/' + parts[2].padStart(2, '0') + '/' + parts[0]
  }
  return hyphenDate
}
